import {
  classNames,
  TagBlockProps,
} from '@payfit/growth-platform-brand-system-v2';
import { Icon } from '@payfit/growth-platform-brand-system-v2/components/Picto/Icon';
import { Popover } from '@payfit/growth-platform-brand-system-v2/components/Popover';
import React from 'react';
import {
  LabelsPricingPageRecord,
  SiteLocale,
} from '../../../../../../types/dato';
import PriceBreakdown from '../../PriceBreakdown';
import { OfferProps, PricesRangeWithTotal } from '../../types';

type BreakdownTooltipProps = {
  labels?: LabelsPricingPageRecord | null;
  pricesRange?: PricesRangeWithTotal | null;
  nbEmployee: number;
  locale: SiteLocale;
  offer: OfferProps;
};

const BreakdownTooltip = ({
  labels,
  pricesRange,
  locale,
  nbEmployee,
  offer,
}: BreakdownTooltipProps) => {
  return (
    <Popover
      popoverClassWidth="md:w-max"
      label={
        <Icon name="question" className={classNames('h-[20px] w-[20px]')} />
      }
      position="right"
      modalOnMediumScreen={true}
      className={classNames('inline')}
    >
      <PriceBreakdown className={classNames('w-full lg:w-[390px]')}>
        <PriceBreakdown.Header
          title={labels?.pricingBreakdownLabels?.title as string}
          text={labels?.pricingBreakdownLabels?.text as string}
          promoTag={offer.labels?.offerTag as TagBlockProps}
          offerTitle={offer.title as string}
          locale={locale}
        />
        {offer.activeFreeMonths && (
          <>
            <PriceBreakdown.Separator />
            <PriceBreakdown.FreeMonths {...offer.activeFreeMonths} />
          </>
        )}
        {pricesRange?.obFees === 0 && (
          <>
            <PriceBreakdown.Separator />
            <PriceBreakdown.Subheader
              oBFeesLabel={
                labels?.pricingBreakdownLabels?.obFeesLabel as string
              }
              oBFeesTag={
                labels?.pricingBreakdownDiscountLabels
                  ?.obFeesTag as TagBlockProps
              }
            />
          </>
        )}
        <PriceBreakdown.Separator />
        <PriceBreakdown.Calculation
          frequencyLabel={
            pricesRange?.labels?.frequencyLabel
              ? pricesRange.labels.frequencyLabel
              : (labels?.pricingBreakdownLabels?.frequencyLabel as string)
          }
          priceLabel={labels?.pricingBreakdownLabels?.priceLabel as string}
          baseLabel={labels?.pricingBreakdownLabels?.baseLabel as string}
          totalLabel={labels?.pricingBreakdownLabels?.totalLabel as string}
          price={pricesRange?.price as number}
          numberEmployee={nbEmployee as number}
          base={pricesRange?.base as number}
          total={pricesRange?.total as number}
          locale={locale}
        />

        {!!pricesRange?.obFees && pricesRange?.obFees > 0 && (
          <>
            <PriceBreakdown.Separator />
            <PriceBreakdown.Footer
              oBFeesTitle={
                labels?.pricingBreakdownLabels?.obFeesTitle as string
              }
              oBFeesLabel={
                labels?.pricingBreakdownLabels?.obFeesLabel as string
              }
              oBFeesPrice={pricesRange?.obFees as number}
              numberEmployee={nbEmployee as number}
              locale={locale}
            />
          </>
        )}
      </PriceBreakdown>
    </Popover>
  );
};

export default BreakdownTooltip;
